import useModal from "../../../useModal";
import Modalheader from "../../../components/header";
import ModalBody from "../../../components/body";
import ModalFooter from "../../../components/footer";
import Button from "../../../../button";
import UseContext from "../../../../../hooks/useContext";
import { useEffect, useState } from "react";
import ApiDatabase from "server";
import { toast } from "react-toastify";

const ModalMissionRefuseCandidat = () => {
  const { toggle } = useModal();
  const { 
    refuseMissionId,
    setRefuseMissionId,
    setModalDataReturn,
    tempWorkerToRefuse,
    setTempWorkerToRefuse,
    updateTempWorkerRefusedState,
    currentRefusedReason,
    currentRefusedReasonComment,
    missionCandidatesLeaving,
  } = UseContext();
  const [isWaiting, setIsWaiting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [reasonRefuses, setReasonRefuses] = useState([]);
  const [reasonSelected, setReasonSelected] = useState('');
  const token = localStorage.getItem('xsrfToken');

  useEffect(() => {
    if (token) {
      setIsWaiting(true);
      ApiDatabase.getReasonRefusesMission(
        { token },
        (data) => {
          setReasonRefuses(data || []);
          if (currentRefusedReason) {
            setReasonSelected(currentRefusedReason);
          }
          setIsWaiting(false);
        },
        (err) => {
          console.log('err', err);
          setIsWaiting(false);
        }
      );
    }
  }, [token]);

  const isEditing = !!currentRefusedReason;

  const handleSubmit = () => {
    if (token && refuseMissionId && tempWorkerToRefuse && reasonSelected) {
      const selectedReasonData = reasonRefuses.find(r => r._id === reasonSelected);
      const refusedData = {
        refusedReason: selectedReasonData?.name || null,
        refusedReasonId: reasonSelected,
        refusedReasonComment: null
      };
      
      const savedTempWorker = tempWorkerToRefuse;
      const savedMissionId = refuseMissionId;
      
      const moveToRefused = () =>
        updateTempWorkerRefusedState(savedTempWorker, true, refusedData);
      // A new refusal lets the card fold away from its list before the move;
      // a card already leaving for another move is moved at once instead.
      const isFolding =
        !isEditing &&
        missionCandidatesLeaving.leave(
          savedMissionId,
          savedTempWorker,
          moveToRefused
        );
      if (!isFolding) {
        moveToRefused();
      }

      setModalDataReturn({ 
        action: isEditing ? 'update_refuse_candidat' : 'refuse_candidat', 
        idTempWorker: tempWorkerToRefuse,
        idMission: savedMissionId,
        refusedReason: refusedData.refusedReason,
        refusedReasonId: refusedData.refusedReasonId,
        refusedReasonComment: refusedData.refusedReasonComment,
      });
      setTempWorkerToRefuse(null);
      setRefuseMissionId(null);
      toggle();
      
      const apiCall = isEditing
        ? ApiDatabase.putTempWorkerAssignationRefused
        : ApiDatabase.postTempWorkerAssignationRefused;

      apiCall(
        { 
          token, 
          idMission: savedMissionId, 
          idTempWorker: savedTempWorker,
          reason: reasonSelected 
        },
        (data) => {
          toast.success(isEditing ? 'Le motif de refus a été modifié' : 'Le candidat a bien été refusé');
        },
        (err) => {
          if (!isEditing) {
            if (isFolding) {
              missionCandidatesLeaving.cancel(savedMissionId, savedTempWorker);
            }
            updateTempWorkerRefusedState(savedTempWorker, false);
          }
          toast.error('Une erreur est survenue : ' + err);
        }
      );
    }
  };

  const handleCancel = () => {
    setTempWorkerToRefuse(null);
    setRefuseMissionId(null);
    toggle();
  };

  return (
    <>
      <Modalheader hide={handleCancel} hideShow={true}>
        {isEditing ? 'Modifier le motif de refus' : 'Refuser le candidat'}
      </Modalheader>
      <ModalBody>
        {isWaiting ? (
          <div className="text-center py-4">Chargement ...</div>
        ) : (
          <div className="flex flex-col gap-4">
            <div className="text-gray-700">
              {isEditing ? 'Modifiez le motif de refus pour ce candidat.' : 'Veuillez sélectionner un motif de refus pour ce candidat.'}
            </div>
            <div>
              <label className="ft-sm text-gray-500">
                <div className="mb-1">Motif de refus</div>
                <select
                  className="w-full h-10 pl-3 pr-8 ft-b border rounded-lg text-gray-900"
                  value={reasonSelected}
                  onChange={(e) => setReasonSelected(e.target.value)}
                >
                  <option value="">Sélectionnez un motif</option>
                  {reasonRefuses.map((reason, index) => (
                    <option key={index} value={reason._id}>
                      {reason.name}
                    </option>
                  ))}
                </select>
              </label>
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button size="LG" color="SECONDARY" onClick={handleCancel}>
          Annuler
        </Button>
        {isLoading ? (
          <Button size="LG" color="DISABLED">
            Confirmation ...
          </Button>
        ) : (
          <Button
            size="LG"
            color="PRIMARY"
            onClick={handleSubmit}
            disabled={!reasonSelected}
          >
            Confirmer
          </Button>
        )}
      </ModalFooter>
    </>
  );
};

export default ModalMissionRefuseCandidat;

